import IconArrow from "@icons/IconArrow";
import "./ButtonIcon.scss";
import { useState } from "react";
import IconNotificacoes from "@icons/IconNotificacoes";

export default function ButtonIcon({
  id = "",
  //Pesquisar
  pesquisar = false,
  onPesquisar = () => null,
  titlePesquisar = null,
  typePesquisar = "submit",
  disabledPesquisar = false,
  //Excluir
  Excluir = false,
  onExcluir = () => null,
  titleExcluir = null,
  typeExcluir = "submit",
  disabledExcluir = false,
  //Editar
  Editar = false,
  onEditar = () => null,
  titleEditar = null,
  typeEditar = "submit",
  disabledEditar = false,
  //Copy
  Copy = false,
  onCopy = () => null,
  titleCopy = null,
  typeCopy = "submit",
  disabledCopy = false,
  //Criar
  Criar = false,
  onCriar = () => null,
  titleCriar = null,
  typeCriar = "submit",
  disabledCriar = false,
  //Arrow
  Arrow = false,
  onArrow = () => null,
  titleArrow = null,
  typeArrow = "submit",
  disabledArrow = false,
  openSetArrow = false,
  setOpenSetArrow = () => null,
  classNameArrow = "",
  //Clear
  Clear = false,
  onClear = () => null,
  titleClear = null,
  typeClear = "submit",
  disabledClear = false,
  //Refresh
  Refresh = false,
  onRefresh = () => null,
  titleRefresh = null,
  typeRefresh = "submit",
  disabledRefresh = false,
  //PointVertical
  PointVertical = false,
  onPointVertical = () => null,
  titlePointVertical = null,
  typePointVertical = "submit",
  disabledPointVertical = false,
  //Notificacao
  Notificacao = false,
  onNotificacao = () => null,
  titleNotificacao = null,
  typeNotificacao = "submit",
  disabledNotificacao = false,
  //MenuLateral
  MenuLateral = false,
  onMenuLateral = () => null,
  titleMenuLateral = null,
  typeMenuLateral = "submit",
  disabledMenuLateral = false,
  //Salvar
  Salvar = false,
  onSalvar = () => null,
  titleSalvar = null,
  typeSalvar = "submit",
  disabledSalvar = false,
  //Upload
  Upload = false,
  onUpload = () => null,
  titleUpload = null,
  typeUpload = "submit",
  disabledUpload = false,
  //Playpause
  Playpause = false,
  onPlaypause = () => null,
  titlePlaypause = null,
  typePlaypause = "submit",
  disabledPlaypause = false,
  PlaypauseClassName = "",
  //
  className = "",
  theme = "1",
  style = {},
}) {
  const [openArrow, setOpenArrow] = useState(false);

  return (
    <>
      <div className={`buttonicon theme${theme} ${className}`}>
        {pesquisar && (
          <button
            className={`pesquisar ${disabledPesquisar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titlePesquisar}
            onClick={onPesquisar}
            type={typePesquisar}
            style={{ background: "none", border: "none" }}
            disabled={disabledPesquisar}
          >
            <i className="fa-light fa-magnifying-glass"></i>
          </button>
        )}
        {Excluir && (
          <button
            className={`excluir ${disabledExcluir ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleExcluir}
            onClick={onExcluir}
            type={typeExcluir}
            style={{ background: "none", border: "none" }}
            disabled={disabledExcluir}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        )}
        {Editar && (
          <button
            className={`editar ${disabledEditar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleEditar}
            onClick={onEditar}
            type={typeEditar}
            style={{ background: "none", border: "none" }}
            disabled={disabledEditar}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </button>
        )}
        {Copy && (
          <button
            className={`copy ${disabledCopy ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleCopy}
            onClick={onCopy}
            type={typeCopy}
            style={{ background: "none", border: "none" }}
            disabled={disabledCopy}
          >
            <i className="fa-solid fa-copy"></i>
          </button>
        )}
        {Salvar && (
          <button
            className={`salvar ${disabledSalvar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleSalvar}
            onClick={onSalvar}
            type={typeSalvar}
            style={{ background: "none", border: "none" }}
            disabled={disabledSalvar}
          >
            <i className="fa-solid fa-floppy-disk"></i>
          </button>
        )}
        {Criar && (
          <button
            className={`criar ${disabledCriar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleCriar}
            onClick={onCriar}
            type={typeCriar}
            style={{ background: "none", border: "none" }}
            disabled={disabledCriar}
          >
            <i className="fa-solid fa-plus"></i>
          </button>
        )}
        {Arrow && (
          <button
            className={`arrow ${
              disabledArrow ? "disabled" : ""
            } ${classNameArrow}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleArrow}
            onClick={() => {
              setOpenSetArrow(!openArrow);
              onArrow();
            }}
            type={typeArrow}
            style={{ background: "none", border: "none" }}
            disabled={disabledArrow}
          >
            <IconArrow className={`iconArrow ${openSetArrow ? "open" : ""}`} />
          </button>
        )}
        {Clear && (
          <button
            className={`clear ${disabledClear ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleClear}
            onClick={onClear}
            type={typeClear}
            style={{ background: "none", border: "none" }}
            disabled={disabledClear}
          >
            <i className="fa-solid fa-eraser"></i>
          </button>
        )}
        {Refresh && (
          <button
            className={`refresh ${disabledRefresh ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleRefresh}
            onClick={onRefresh}
            type={typeRefresh}
            style={{ background: "none", border: "none" }}
            disabled={disabledRefresh}
          >
            <i className="fa-solid fa-arrows-rotate"></i>
          </button>
        )}
        {PointVertical && (
          <button
            className={`pointvertical ${
              disabledPointVertical ? "disabled" : ""
            }`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titlePointVertical}
            onClick={onPointVertical}
            type={typePointVertical}
            style={{ background: "none", border: "none" }}
            disabled={disabledPointVertical}
          >
            <i className="fas fa-ellipsis-vertical"></i>
          </button>
        )}
        {Notificacao && (
          <button
            className={`notificacao ${disabledNotificacao ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleNotificacao}
            onClick={onNotificacao}
            type={typeNotificacao}
            style={{ background: "none", border: "none" }}
            disabled={disabledNotificacao}
          >
            <IconNotificacoes />
          </button>
        )}
        {MenuLateral && (
          <button
            className={`menulateral ${disabledMenuLateral ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleMenuLateral}
            onClick={onMenuLateral}
            type={typeMenuLateral}
            style={{ background: "none", border: "none" }}
            disabled={disabledMenuLateral}
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        )}
        {Upload && (
          <button
            className={`upload ${disabledUpload ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titleUpload}
            onClick={onUpload}
            type={typeUpload}
            style={{ background: "none", border: "none" }}
            disabled={disabledUpload}
          >
            <i className="fa-solid fa-upload"></i>
          </button>
        )}
        {Playpause && (
          <button
            className={`playpause ${
              disabledPlaypause ? "disabled" : ""
            } ${PlaypauseClassName}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={titlePlaypause}
            onClick={onPlaypause}
            type={typePlaypause}
            style={{ background: "none", border: "none" }}
            disabled={disabledPlaypause}
          >
            <i class="fa-solid fa-play-pause"></i>
          </button>
        )}
      </div>
    </>
  );
}
